import { TextData, TextFilterData, TextTagData } from '../dto/EntityRepository';
import { UpdateTextBlockReq, UpdateTextReq } from '../dto/ReqDtoRepository';

export const toTextListFilterData = (
  selectedTags: Pick<TextTagData, 'id'>[],
): TextFilterData => ({
  tagIds: selectedTags.map((tag) => tag.id),
});

export const toTextTagIds = (tags: TextTagData[] | undefined): number[] | undefined =>
  tags === undefined ? undefined : tags.map((tag) => tag.id);

type ToUpdateTextReqOptions = {
  textBlocks?: UpdateTextBlockReq[];
  /**
   * true: tags가 있으면 최종 tagIds를 보낸다. 없으면 키 생략(유지).
   * false: tagIds를 보내지 않는다. toggle-access·프로젝트 PE 수정용.
   */
  includeTagIds?: boolean;
};

export const toUpdateTextReq = (
  text: TextData,
  options: ToUpdateTextReqOptions = {},
): UpdateTextReq => {
  const { includeTagIds = true, textBlocks } = options;
  const req: UpdateTextReq = {
    id: text.id,
    source: text.source,
    title: text.title,
    subtitle: text.subtitle,
    prodYear: text.prodYear,
    isPublic: text.isPublic,
  };
  if (textBlocks && textBlocks.length > 0) {
    req.textBlocks = textBlocks;
  }
  if (includeTagIds) {
    const tagIds = toTextTagIds(text.tags);
    if (tagIds !== undefined) {
      req.tagIds = tagIds;
    }
  }
  return req;
};
